export const mixedString = 'Mixed';

export class Mimic {
    id: string;
    folderId: string;
    svgcontent: string;
    name: string;
    vesselId: string;
    createdAt: Date;
    updatedAt: Date;
    locked: boolean;
    userId: string;
    profile: MimicProfile;
    index: number;
}

export class MimicProfile {
    bkcolor: string;
    color: string;
    grid: number;
    allowGrid: boolean;
    width: number;
    height: number;
    margin: number;
}
